import React, { useEffect, createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const META_PIXEL_ID = '837864705897680';
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
function installMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.fbq) return;
  try {
    // Standard Meta Pixel bootstrap, but safe against missing <script> tags
    // in environments where document.getElementsByTagName('script')[0] is undefined.
    const w = window as Window & {
      fbq?: any;
      _fbq?: any;
    };
    if (!w.fbq) {
      const n: any = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      // Fallback: no existing <script> tag found, append directly to <head>.
      ;
      (document.head || document.documentElement).appendChild(script);
    }
    window.fbq?.('init', META_PIXEL_ID);
    window.fbq?.('track', 'PageView');
    // noscript fallback pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    (document.head || document.documentElement).appendChild(noscript);
  } catch (err) {
    // Never let pixel installation crash the app.
    // eslint-disable-next-line no-console
    console.warn('[Meta Pixel] install failed', err);
  }
}
function Root() {
  useEffect(() => {
    installMetaPixel();
  }, []);
  return <App data-id="element-393" />;
}
render(<Root data-id="element-394" />, document.getElementById('root'));